import { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { TextInput } from "../../../components/controls/inputs/BaseInput";
import BaseCreator from "../../../components/creators/baseCreator";
import modalStyles from '../../../components/modalWindows/styles/BaseModalWindow.module.scss'
import { useForm } from "../../../system/hooks/useForm";
import { ITaskProgramEditDTO, ITaskProgramToStoreDto } from "../../../libs/coreapi-dto/dirs/taskProgram";
import GridMultipleSelectorInput from "../../../components/controls/GridMultipleSelectorInput";
import StoreSelectorModal from "../Store/StoreSelectorModal";
import { v4 as uuidv4 } from 'uuid';
import { IEntitySimpleDTO } from "../../../libs/coreapi-dto/@types/common";
import { DefaultGrid } from "../../../components/grids/default/defaultGrid";
import TaskProgramStorePluginSetting from "./TaskProgramStore/TaskProgramPluginSetting";
import useGridFilter from "../../../system/hooks/useGridFilter";

type Validator = ITaskProgramEditDTO

const TaskProgramCreatorModal: FC<ICreatorModalProps<ITaskProgramEditDTO>> = (props) => {
    const [data, setData] = useState<ITaskProgramEditDTO>(props.data ?? {} as ITaskProgramEditDTO);
    const [dataToStores, setDataToStores] = useState<ITaskProgramToStoreDto[]>(props.data?.taskProgramToStores ?? [])
    const { t } = useTranslation();    
    const errorsT = (value: string) => t('errors.' + value);
    const [selectedItem, setSelectedItem] = useState<IGridRow | undefined>(); 
    const [gridFilter, dispatchGridFilter] = useGridFilter();
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
    const selectedEntities: IEntitySimpleDTO[] = dataToStores.map(s => ({ idGlobal: s.idStoreGlobal, displayName: s.storeName }));

    useEffect(() => {
        setData((prev) => ({
            ...prev,
            taskProgramToStores: dataToStores
        }))
    }, [dataToStores])

    useEffect(() => {
        if (data.idTaskProgramGlobal === undefined || props.variant === 'copy') {
            setData((prev) => ({
                ...prev,
                idTaskProgramGlobal: uuidv4(),            
            }))     
        }            
    }, []) 

    useEffect(() => {
        setDataToStores(dataToStores.map((x) => {
            return{
                idStoreGlobal: x.idStoreGlobal,
                idTaskProgramGlobal: data.idTaskProgramGlobal,
                storeName: x.storeName,
                idGosContractTypeGlobal: x.idGosContractTypeGlobal,
                idTaskProgramToStoreGlobal: uuidv4(),
                store: x.storeName
            }
        }))          
    }, [data.idTaskProgramGlobal]) 

    const updateStoresFromSelectedEntities = (entities: IEntitySimpleDTO[]) => {
        setDataToStores(entities.map((entity) => {
            const existingStore = dataToStores.find((store) => store.idStoreGlobal === entity.idGlobal);

            return {
                idTaskProgramToStoreGlobal: existingStore?.idTaskProgramToStoreGlobal ?? uuidv4(),
                idTaskProgramGlobal: data.idTaskProgramGlobal,
                idGosContractTypeGlobal: existingStore?.idGosContractTypeGlobal,
                idStoreGlobal: entity.idGlobal,
                storeName: entity.displayName
            }
        }))
        setSelectedItem(undefined)
    }
     
    const { isValid, errors, setErrors } = useForm<Validator>({        
        validations: {
            taskProgramToStores: {
                required: {                    
                    value: data.taskProgramToStores? false :true,
                    message: errorsT("required")      
                }
             },    
             programName: {
                required: {
                    value: data.programName? false: true,
                    message: errorsT("required")  
                }
             }
        }
    });

    const handleSubmit = () => {
         if (isValid()) {
            props.save({ ...data })
            setIsSubmitting(true)
        }
    }

    return (
        <BaseCreator
            variant={props.variant}
            isSubmitting={isSubmitting}
            save={handleSubmit}
            cancel={props.cancel}
            modalWindowClassName={modalStyles.flexModalWindow}
            valid={!props.lockFromPermission}
        >

            <TextInput 
                required
                label={'Наименование программы'} 
                value={data.programName}        
                onChange={(value) => setData({...data, programName: value})}
                error={errors.programName} 
                onFocus={() => setErrors({ ...errors, programName: undefined })}
                disabled={props.lockFromPermission}
            />

            <TextInput label={'Комментарий'} value={data.comment}        
                onChange={(value) => setData({...data, comment: value})}
                disabled={props.lockFromPermission}
            />

            <GridMultipleSelectorInput
            selectorModalJsx={StoreSelectorModal}
            inline={false}
            selectedEntities={selectedEntities}
            label={'Склады'}
            error={errors.taskProgramToStores}
            onFocus={() => setErrors({...errors, taskProgramToStores: undefined})}
            onSelect={(entities) => {
                updateStoresFromSelectedEntities(entities)
            }}
            onClear={() => {
                updateStoresFromSelectedEntities([])
            }}
            disabled={props.lockFromPermission}
            /> 
          <DefaultGrid
            gridId={uuidv4()}
            data={dataToStores}
            totalCount={0}
            plugin={TaskProgramStorePluginSetting}
            selectedItem={selectedItem}
            filter={gridFilter}
            onSelect={(row) => {
                setSelectedItem(row)
            }}
            onSort={(i) => {
                dispatchGridFilter({ type: "sort", payload: i.propertyName });
            }}
            onFilterDelete={(i) => {}}
            onPageNumberChange={(n) => {}}
            onNumberPerPageChange={(n) => {}}  
        >

        </DefaultGrid>            
           
        </BaseCreator>
    )
}

export default TaskProgramCreatorModal
